import { render, staticRenderFns } from "./CreatedFileScroll.vue?vue&type=template&id=3ebb9d3e&scoped=true"
import script from "./CreatedFileScroll.vue?vue&type=script&lang=js"
export * from "./CreatedFileScroll.vue?vue&type=script&lang=js"
import style0 from "./CreatedFileScroll.vue?vue&type=style&index=0&id=3ebb9d3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb9d3e",
  null
  
)

export default component.exports